







































































































import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';

export default Vue.extend({
  name: 'Process',

  data: () => ({
    perplexity: {
      min: 1,
      max: 50,
      label: 'Perplexity',
      val: 1,
      color: 'red',
    },
    epsilon: {
      min: 1,
      max: 50,
      label: 'Epsilon',
      val: 1,
      color: 'orange',
    },
    iterations: {
      min: 1,
      max: 20000,
      label: 'Iterations',
      val: 1,
      color: 'green',
    },
  }),

  computed: {
    ...mapGetters('data', [
      'getTracks',
    ]),

    ...mapGetters('map', [
      'getPerplexity',
      'getEpsilon',
      'getIterations',
      'getCurrentIteration',
      'isProcessDone',
    ]),

    disableSliders() {
      if (!this.isProcessDone) {
        return true;
      }
      return false;
    },
  },

  created() {
    this.perplexity.max = this.getTracks.length;
    this.perplexity.val = this.getPerplexity;
    this.epsilon.val = this.getEpsilon;
    this.iterations.val = this.getIterations;
  },

  methods: {
    ...mapActions('map', [
      'processData',
      'abort',
    ]),

    ...mapActions('data', [
      'save',
    ]),

    changeSettings() {
      this.$store.dispatch('map/changeSettings', {
        perplexity: this.perplexity.val,
        epsilon: this.epsilon.val,
        iterations: this.iterations.val,
      });
    },

    run() {
      if (this.isProcessDone) {
        this.processData();
      } else {
        this.abort();
      }
    },
  },
});
